import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';
import AuthService from '@/shared/services/AuthService';
import moment from 'moment';
import messages from '../budgetMessages';

const currentYear = moment.utc().year();

export default class UpdateBudgetAmountModal extends Component {
  state = {
    selectedUpdateMethod: 0,
    overrideBudget: false,
    referenceYear: currentYear - 1,
    budgetYear: currentYear,
    hours: 0,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    year: PropTypes.number, // Year from filters
  };
  static defaultProps = {
    year: null,
  };
  componentDidMount() {
    const { intl, year } = this.props;
    const budgetYear = year || moment.utc().year();
    const updateMethods = [
      {
        id: 0,
        label: intl.formatMessage(messages.NewQuantity),
      },

      {
        id: 1,
        label: intl.formatMessage(messages.UseRegistrationHoursForBudget),
      },
    ];

    if (AuthService.hasFeature('CapacityPlanning')) {
      updateMethods.push({
        id: 2,
        label: intl.formatMessage(messages.UsePlannedHoursForBudget),
      });
    }

    const referenceYears = [budgetYear, budgetYear - 1, budgetYear - 2, budgetYear - 3];
    this.setState({ referenceYear: budgetYear - 1, budgetYear, updateMethods, referenceYears });
  }

  isFormInvalid = () => {
    const { referenceYear, selectedUpdateMethod, hours } = this.state;
    if (!referenceYear || referenceYear < 2000) return true;
    if (selectedUpdateMethod === 0 && (Number.isNaN(hours) || hours < 0)) return true;

    return false;
  };

  onSave = () => {
    const { overrideBudget, selectedUpdateMethod, referenceYear, budgetYear, hours } = this.state;

    const { onSave } = this.props;

    const amountUpdate = {
      method: selectedUpdateMethod,
      overrideBudget,
      referenceYear,
      budgetYear,
      hours,
    };

    return onSave(amountUpdate);
  };

  methodChanged = e => {
    const value = parseInt(e.target.value);
    this.setState({ selectedUpdateMethod: value });
  };

  render() {
    const { show, onClose, intl } = this.props;
    const {
      overrideBudget,
      selectedUpdateMethod,
      updateMethods,
      referenceYear,
      budgetYear,
      hours,
      referenceYears,
    } = this.state;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.UpdateHoursForYear, { year: budgetYear })}
        show={show}
        onClose={onClose}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <label className="control-label col-sm-3">{intl.formatMessage(messages.Method)}</label>
            <div className="col-sm-8">
              {updateMethods && (
                <select
                  onChange={this.methodChanged}
                  className="form-control"
                  value={selectedUpdateMethod}
                >
                  {updateMethods.map(x => (
                    <option key={x.id} value={x.id}>
                      {x.label}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>

          {selectedUpdateMethod === 1 ? (
            <div className="form-group">
              <label className="control-label col-sm-3">
                {intl.formatMessage(messages.BudgetBasedOnYear)}
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={referenceYear || ''}
                  onChange={e => this.setState({ referenceYear: parseInt(e.target.value) || null })}
                >
                  {referenceYears.map(y => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : null}

          {selectedUpdateMethod === 0 ? (
            <div className="form-group">
              <label className="control-label col-sm-3">{intl.formatMessage(messages.Hours)}</label>
              <div className="col-sm-8">
                <input
                  type="number"
                  className="form-control"
                  id="hours"
                  min={0}
                  max="99999999999.99"
                  step="any"
                  value={hours || ''}
                  onChange={e => this.setState({ hours: parseFloat(e.target.value) || null })}
                />
              </div>
            </div>
          ) : null}

          <div className="form-group">
            <Checkbox
              extraClass="col-sm-offset-3 col-md-8"
              id="overrideBudget"
              value={overrideBudget}
              onClick={() => this.setState({ overrideBudget: !overrideBudget })}
              text={intl.formatMessage(messages.OverrideIfBudgetExists)}
            />
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
